import React from 'react';

const News = () => {
  const posts = [
    {
      id: 1,
      title: 'Future of Polymer Industry: Sustainable Solutions and Market Trends',
      excerpt: 'Explore the latest trends in the polymer industry, including sustainable practices, recycling innovations, and market forecasts for 2024.',
      content: 'The polymer industry is experiencing significant transformation driven by sustainability initiatives, technological advancements, and evolving market demands. This article explores key trends including circular economy practices, bio-based polymers, and the growing importance of recycled materials in the supply chain.',
      category: 'polymer',
      featured: true,
      image_url: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 2,
      title: 'Recycled Polymers: Driving Circular Economy in Manufacturing',
      excerpt: 'Learn how recycled polymers are revolutionizing manufacturing processes and contributing to environmental sustainability.',
      content: 'Recycled polymers are becoming increasingly important in the manufacturing sector. Companies are adopting circular economy principles, using recycled materials to reduce waste and environmental impact. This shift is creating new opportunities for suppliers and buyers in the polymer market.',
      category: 'polymer',
      featured: true,
      image_url: '/assets/images/polymers/recycle1.webp',
      publish_date: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 3,
      title: 'Polymer Price Volatility: Understanding Market Dynamics',
      excerpt: 'An in-depth analysis of polymer price fluctuations and factors influencing market stability in 2024.',
      content: 'Polymer prices have shown significant volatility in recent years due to various factors including raw material costs, supply chain disruptions, and global economic conditions. Understanding these dynamics is crucial for businesses in the polymer trading sector.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 4,
      title: 'Innovations in Polymer Processing: Technology Trends',
      excerpt: 'Discover the latest technological innovations transforming polymer processing and manufacturing.',
      content: 'Advanced technologies are revolutionizing polymer processing, from AI-driven quality control to automated production systems. These innovations are improving efficiency, reducing costs, and enabling new applications for polymer materials.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 5,
      title: 'Global Polymer Trade: Opportunities and Challenges',
      excerpt: 'Exploring the expanding global polymer trade market and emerging opportunities for businesses.',
      content: 'The global polymer trade market is expanding rapidly, with new opportunities emerging in various regions. However, businesses must navigate challenges including regulatory compliance, logistics complexities, and currency fluctuations.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 6,
      title: 'Polymer Grade Selection: A Comprehensive Guide',
      excerpt: 'Understanding different polymer grades and how to select the right material for your application.',
      content: 'Selecting the right polymer grade is crucial for product performance and cost optimization. This guide covers various polymer grades, their properties, applications, and factors to consider when making purchasing decisions.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 7,
      title: 'Supply Chain Optimization in Polymer Industry',
      excerpt: 'How digital platforms are transforming polymer supply chains and improving efficiency.',
      content: 'Digital transformation is reshaping polymer supply chains, enabling real-time tracking, automated procurement, and improved logistics coordination. These innovations are helping businesses reduce costs and improve service delivery.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 18 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 8,
      title: 'Polymer Quality Standards: Ensuring Material Excellence',
      excerpt: 'Understanding quality standards and certifications in the polymer industry.',
      content: 'Quality standards play a critical role in the polymer industry, ensuring materials meet specific requirements for various applications. This article explores key standards, testing procedures, and certification processes.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 9,
      title: 'Bio-Based Polymers: The Next Generation of Sustainable Materials',
      excerpt: 'Exploring the rise of bio-based polymers and their impact on sustainable manufacturing.',
      content: 'Bio-based polymers are gaining traction as sustainable alternatives to traditional petroleum-based materials. These innovative materials offer reduced environmental impact while maintaining performance characteristics required for various applications.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 22 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 10,
      title: 'Polymer Market Outlook 2024: Growth Opportunities and Industry Forecast',
      excerpt: 'Comprehensive analysis of the polymer market outlook for 2024, including growth sectors and emerging trends.',
      content: 'The polymer market is poised for significant growth in 2024, driven by increasing demand across various industries including packaging, automotive, construction, and electronics. This article provides insights into market trends, growth opportunities, and factors shaping the industry landscape.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 11,
      title: 'HDPE vs LDPE: Choosing the Right Polymer for Your Application',
      excerpt: 'A detailed comparison of HDPE and LDPE polymers, their properties, applications, and selection criteria.',
      content: 'High-Density Polyethylene (HDPE) and Low-Density Polyethylene (LDPE) are two of the most widely used polymers in the industry. Understanding their differences in strength, flexibility, chemical resistance, and cost is essential for making informed purchasing decisions.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 28 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 12,
      title: 'Polypropylene (PP) Market Trends: Applications and Future Prospects',
      excerpt: 'Exploring the growing demand for polypropylene across various industries and emerging market opportunities.',
      content: 'Polypropylene continues to be one of the fastest-growing polymer markets globally. Its versatility, cost-effectiveness, and recyclability make it ideal for applications in automotive, packaging, textiles, and medical devices. This article examines current market trends and future growth prospects.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 13,
      title: 'PET Polymer Recycling: Transforming Waste into Valuable Resources',
      excerpt: 'How PET recycling is creating new opportunities in the polymer industry and reducing environmental impact.',
      content: 'Polyethylene Terephthalate (PET) recycling has become a cornerstone of sustainable polymer practices. Advanced recycling technologies are enabling the transformation of PET waste into high-quality recycled materials suitable for food-grade applications, creating a circular economy model.',
      category: 'polymer',
      featured: false,
      image_url: '/assets/images/polymers/recycle3.webp',
      publish_date: new Date(Date.now() - 32 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 14,
      title: 'Polymer Additives: Enhancing Material Performance and Properties',
      excerpt: 'Understanding the role of additives in polymer manufacturing and their impact on material characteristics.',
      content: 'Polymer additives play a crucial role in enhancing material properties such as UV resistance, flame retardancy, color stability, and mechanical strength. This comprehensive guide covers various types of additives, their functions, and best practices for polymer formulation.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 35 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 15,
      title: 'Import-Export Regulations in Polymer Trade: A Complete Guide',
      excerpt: 'Navigating international trade regulations, customs duties, and compliance requirements for polymer materials.',
      content: 'International polymer trade involves navigating complex regulatory frameworks, customs procedures, and compliance requirements. This guide provides essential information on documentation, duty structures, quality certifications, and best practices for successful cross-border polymer trading.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 38 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 16,
      title: 'Polymer Packaging Industry: Innovations and Sustainability Trends',
      excerpt: 'Exploring the latest innovations in polymer packaging and the shift towards sustainable solutions.',
      content: 'The polymer packaging industry is evolving rapidly with innovations in barrier properties, lightweighting, and sustainable materials. Companies are investing in recyclable and compostable packaging solutions to meet consumer demands and regulatory requirements.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 40 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 17,
      title: 'Polymer Testing and Quality Assurance: Industry Best Practices',
      excerpt: 'Essential testing methods and quality assurance protocols for ensuring polymer material excellence.',
      content: 'Quality assurance in the polymer industry requires comprehensive testing protocols including mechanical testing, thermal analysis, chemical resistance evaluation, and environmental stress testing. This article outlines industry-standard testing methods and quality control measures.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 42 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 18,
      title: 'Polymer Storage and Handling: Best Practices for Material Preservation',
      excerpt: 'Guidelines for proper storage, handling, and preservation of polymer materials to maintain quality.',
      content: 'Proper storage and handling of polymer materials are critical for maintaining their properties and extending shelf life. This guide covers temperature control, moisture protection, UV shielding, and other essential practices for polymer material management.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 19,
      title: 'Polymer Industry Digitalization: Technology Transforming the Sector',
      excerpt: 'How digital technologies are revolutionizing polymer manufacturing, trading, and supply chain management.',
      content: 'Digital transformation is reshaping the polymer industry through IoT-enabled manufacturing, blockchain-based supply chain tracking, AI-powered quality control, and data analytics for market forecasting. These technologies are improving efficiency and transparency across the value chain.',
      category: 'polymer',
      featured: false,
      image_url: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=600&fit=crop',
      publish_date: new Date(Date.now() - 48 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      id: 20,
      title: 'Polymer Waste Management: Strategies for Sustainable Disposal',
      excerpt: 'Effective strategies for managing polymer waste and promoting sustainable disposal practices.',
      content: 'Effective polymer waste management is essential for environmental sustainability. This article explores various strategies including mechanical recycling, chemical recycling, energy recovery, and waste-to-energy conversion, along with their environmental and economic implications.',
      category: 'polymer',
      featured: false,
      image_url: '/assets/images/polymers/recycle4.webp',
      publish_date: new Date(Date.now() - 50 * 24 * 60 * 60 * 1000).toISOString()
    }
  ];

  return (
    <>
      <section className="page-header">
        <div className="container">
          <h1>News & Blog</h1>
          <p>Stay updated with latest industry news and insights</p>
        </div>
      </section>

      <section className="section-padding">
        <div className="container">
          <div className="section-header">
            <h2>Latest Updates</h2>
            <p>Recent news, announcements, and industry insights from BSB Fortrade</p>
          </div>
          
          <div className="news-grid">
            {posts.length > 0 ? (
              posts.map((post, index) => (
                <div key={post.id || index} className="news-card">
                  <div className="news-image">
                    {post.image_url ? (
                      <img 
                        src={post.image_url} 
                        alt={post.title}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          if (e.target.nextSibling) {
                            e.target.nextSibling.style.display = 'flex';
                          }
                        }}
                      />
                    ) : null}
                    <div className="news-image-placeholder" style={{ display: post.image_url ? 'none' : 'flex' }}>
                      <i className="fas fa-newspaper"></i>
                    </div>
                  </div>
                  <div className="news-content">
                    <div className="news-meta">
                      <span className="news-category">
                        <i className="fas fa-tag"></i> {post.category ? post.category.replace('-', ' ') : 'Company News'}
                      </span>
                      <span className="news-date">
                        <i className="fas fa-calendar"></i> {post.publish_date ? new Date(post.publish_date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : new Date().toLocaleDateString()}
                      </span>
                    </div>
                    <h3>{post.title}</h3>
                    <p>{post.excerpt || (post.content ? post.content.substring(0, 150) : '')}</p>
                    <a href="#" className="read-more">Read More <i className="fas fa-arrow-right"></i></a>
                  </div>
                </div>
              ))
            ) : (
              <div className="news-card">
                <p>No news articles available at the moment.</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default News;

